import React from 'react';
import './About.css';

import { Button, Heading} from '../../../components'; // Import necessary components
import { about } from '../../../constants';



const About = () => {

  const { sub, heading, description, points, image, button } = about;

  return (
    <section className="about">
      {/* About Image */}
      <div className="image">
        <div className='sub-image one'>
          <img src={image.src1} alt={image.alt1} />
          <img src={image.src2} alt={image.alt2} />
        </div>
        <div className='sub-image two'>
          <img src={image.src3} alt={image.alt3} />
          <img src={image.src4} alt={image.alt4} />
        </div>
        <div className="experience">
          <div className="icon">{image.experience.icon}</div>
          <span>{image.experience.years}</span>
          <p>{image.experience.title}</p>
        </div>
      </div>

      {/* Introduction Content */}
      <div className="content">

        {/* Section Heading */}
        <Heading title={heading} subTitle={sub} sideHeading />

        {/* Description */}
        <p>{description}</p>

        {/* Key Features */}
        <div className="about-features">
          {points.map((point, index) => (
            <div className="item" key={index}>
              <div className="icon">{point.icon}</div>
              <h3>{point.title}</h3>
              <p>{point.content}</p>
            </div>
          ))}
        </div>

        {/* Button Component: Links to a specific page or action */}
        <Button link={button.link} title={button.text} />

      </div>
    </section>
  );
};

export default About;